import { apiClient } from "features/shared/api/axiosInstance";

export const organizationApi = {
    getBalance: (address: string) => apiClient.get<string>(`/api/organization/${address}/balance`),
};
